/*
  SCRIPT PARA MARQUEE INFINITO
  Ele clona o texto base quantas vezes forem necessárias
  para preencher a tela inteira, garantindo loop limpo.
*/

document.addEventListener('DOMContentLoaded', () => {
  const initMarquee = () => {
    document.querySelectorAll('.custom-marquee').forEach(marquee => {
      const track = marquee.querySelector('.marquee-track');
      let originalBlock = track.querySelector('.marquee-content-original');
      if (!track || !originalBlock) return;

      const setupMarquee = () => {
        // Remove os clones anteriores no caso de redimensionamento da tela
        track.querySelectorAll('.marquee-content-clone').forEach(el => el.remove());
        
        // Como podemos ter duplicado itens DENTRO do bloco original na última vez,
        // precisamos recuperar e aplicar o HTML inicial puro para medir e clonar corretamente.
        if (!originalBlock.hasAttribute('data-initial-html')) {
          originalBlock.setAttribute('data-initial-html', originalBlock.innerHTML);
        } else {
          originalBlock.innerHTML = originalBlock.getAttribute('data-initial-html');
        }

        const itemWidth = originalBlock.offsetWidth;
        const windowWidth = window.innerWidth;
        
        // Se o comprimento for zero por erro ou display:none, ignora.
        if (itemWidth === 0) return;

        // Verifica quantas vezes o texto interno precisa se repetir para
        // preencher toda a tela sozinhos (a largura da janela).
        const repeatsInside = Math.ceil(windowWidth / itemWidth);
        const initialHTML = originalBlock.getAttribute('data-initial-html');

        // Multiplica o conteúdo dentro do bloco original para garantir 
        // que ele seja, no mínimo, mais largo do que a tela.
        let newHTML = initialHTML;
        for (let i = 1; i < repeatsInside; i++) {
          newHTML += initialHTML;
        }
        originalBlock.innerHTML = newHTML;

        // Agora que o bloco original está cheio, nós o duplicamos INTEIRO EXATAMENTE UMA VEZ.
        // Assim, a animação que desliza -50% passará pelo conteúdo e voltará
        // de forma matemática, resultando num scroll absolutamente perfeito, sem espaço branco.
        const cloneBlock = originalBlock.cloneNode(true);
        cloneBlock.classList.remove('marquee-content-original');
        cloneBlock.classList.add('marquee-content-clone');
        cloneBlock.setAttribute('aria-hidden', 'true');
        track.appendChild(cloneBlock);
      };

      setupMarquee();
      window.addEventListener('resize', debounce(setupMarquee, 250));
    });
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  // Roda logo agora e no momento que a seção for construída/reconstruída no Editor Shopify
  initMarquee();
  document.addEventListener('shopify:section:load', initMarquee);
});
